import './DaySeparator.styles.scss';

export type tDaySeparatorProps = {
  /** "Hoy", "Ayer", "Sábado", "15 sep", "28 dic 2025". */
  label: string;
  /** Local day, "YYYY-MM-DD"; the floating chip reads it back while scrolling. */
  dayKey: string;
};

/** The chip that opens each day of the conversation, as in WhatsApp. */
export default function DaySeparator(props: tDaySeparatorProps) {
  const { label, dayKey } = props;

  return (
    <div className="DaySeparator" data-day-separator={dayKey} data-label={label}>
      <span className="DaySeparator__Chip">{label}</span>
    </div>
  );
}
